export default __webpack_public_path__ + "static/media/Linkedin Learning Network+ prep 2 The Physical Network.8727917c.webp";